module.exports = __webpack_public_path__ + "img/logo-preto-refuturiza.81defe19.svg";